import apiService from '../../../services/api-client';
import { DeleteCategoryResponse } from '../interfaces/delete-category';
import { DeleteFormatResponse } from '../interfaces/delete-format';
import { DeleteGenreResponse } from '../interfaces/delete-genre';
import { DeletePriceRangeResponse } from '../interfaces/delete-price-range';
import { DeleteTypeResponse } from '../interfaces/delete-type';
import { GetProductCategoriesResponse } from '../interfaces/get-product-categories';
import { GetFormatsResponse } from '../interfaces/get-formats';
import { GetGenresResponse } from '../interfaces/get-genres';
import { GetPriceRangesResponse } from '../interfaces/get-price-ranges';
import { GetProductTypesResponse } from '../interfaces/get-product-types';
import { PostFormatPayloadRequest, PostFormatResponse } from '../interfaces/post-format';
import { PostGenrePayloadRequest, PostGenreResponse } from '../interfaces/post-genre';
import { PostPriceRangePayloadRequest, PostPriceRangeResponse } from '../interfaces/post-price-range';
import { PostTypePayloadRequest, PostTypeResponse } from '../interfaces/post-type';
import { PutCategoryPayloadRequest, PutCategoryResponse } from '../interfaces/put-category';
import { PutFormatPayloadRequest, PutFormatResponse } from '../interfaces/put-format';
import { PutGenrePayloadRequest, PutGenreResponse } from '../interfaces/put-genre';
import { PutPriceRangePayloadRequest, PutPriceRangeResponse } from '../interfaces/put-price-range';
import { PutTypePayloadRequest, PutTypeResponse } from '../interfaces/put-type';
import { GetWarehouseTypesResponse } from '../interfaces/get-warehouse-types';
import { GetLocationTypesResponse } from '../interfaces/get-location-types';
import { GetContainerTypesResponse } from '../interfaces/get-container-types';
import { GetChannelTypesResponse } from '../interfaces/get-channel-types';
import { GetContainerCategoriesResponse } from '../interfaces/get-container-categories';
import { PostContainerCategoryPayloadRequest, PostContainerCategoryResponse } from '../interfaces/post-container-category';
import { PostProductCategoryPayloadRequest, PostProductCategoryResponse } from '../interfaces/post-product-category';
import { GetAcquisitionTypesResponse } from '../interfaces/get-adquisition-types';
import { GetReceptionTypesResponse } from '../interfaces/get-reception-types';
import { PostProductAttributeValuePayloadRequest, PostProductAttributeValueResponse } from '../interfaces/post-product-attribute-value';
import { GetProductUsagesResponse } from '../interfaces/get-product-usages';
import { GetProductPackagingsResponse } from '../interfaces/get-product-packagings';
import { GetProductFunctionalitiesResponse } from '../interfaces/get-product-functionalities';
import { GetProductAestheticsResponse } from '../interfaces/get-product-aesthetics';
import { GetProductCompletenessesResponse } from '../interfaces/get-product-completenesses';
import { GetProductStatesResponse } from '../interfaces/get-product-states';
import { PutProductAttributeValuePayloadRequest, PutProductAttributeValueResponse } from '../interfaces/put-product-attribute-value';
import { DeleteProductAttributeResponse } from '../interfaces/delete-product-attribute';
import { GetContainerRecipientTypesResponse } from '../interfaces/get-container-recipient-types';

export const mastersApiService = {
  async getProductTypes(id: number) {
    const { data } = await apiService().get<GetProductTypesResponse>(`company/${id}/productTypes`, { params: { size: 10000 } });
    return data;
  },
  async getWarehouseTypes(id: number) {
    const { data } = await apiService().get<GetWarehouseTypesResponse>(`company/${id}/warehouseTypes`, { params: { size: 10000 } });
    return data;
  },
  async getLocationTypes(id: number) {
    const { data } = await apiService().get<GetLocationTypesResponse>(`company/${id}/locationTypes`, { params: { size: 10000 } });
    return data;
  },
  async getContainerTypes(id: number) {
    const { data } = await apiService().get<GetContainerTypesResponse>(`company/${id}/containerTypes`, { params: { size: 10000 } });
    return data;
  },
  async getChannelTypes(id: number) {
    const { data } = await apiService().get<GetChannelTypesResponse>(`company/${id}/channelTypes`, { params: { size: 10000 } });
    return data;
  },
  async getAcquisitionTypes(id: number) {
    const { data } = await apiService().get<GetAcquisitionTypesResponse>(`company/${id}/acquisitionTypes`, { params: { size: 10000 } });
    return data;
  },
  async getReceptionTypes(id: number) {
    const { data } = await apiService().get<GetReceptionTypesResponse>(`company/${id}/receptionTypes`, { params: { size: 10000 } });
    return data;
  },
  async getProductCategories(id: number) {
    const { data } = await apiService().get<GetProductCategoriesResponse>(`company/${id}/productCategories`, { params: { size: 10000 } });
    return data;
  },
  async getContainerCategories(id: number) {
    const { data } = await apiService().get<GetContainerCategoriesResponse>(`company/${id}/containerCategories`, { params: { size: 10000 } });
    return data;
  },
  async getFormats(id: number) {
    const { data } = await apiService().get<GetFormatsResponse>(`company/${id}/productFormats`, { params: { size: 10000 } });
    return data;
  },
  async getGenres(id: number) {
    const { data } = await apiService().get<GetGenresResponse>(`company/${id}/productGenres`, { params: { size: 10000 } });
    return data;
  },
  async getPriceRanges(id: number) {
    const { data } = await apiService().get<GetPriceRangesResponse>(`company/${id}/priceRanges`, { params: { size: 10000 } });
    return data;
  },
  async getProductUsages(id: number) {
    const { data } = await apiService().get<GetProductUsagesResponse>(`company/${id}/productUsage`);
    return data;
  },
  async getProductPackagings(id: number) {
    const { data } = await apiService().get<GetProductPackagingsResponse>(`company/${id}/productPackaging`);
    return data;
  },
  async getProductFuntionalities(id: number) {
    const { data } = await apiService().get<GetProductFunctionalitiesResponse>(`company/${id}/productFunctionalities`);
    return data;
  },
  async getProductAesthetics(id: number) {
    const { data } = await apiService().get<GetProductAestheticsResponse>(`company/${id}/productAesthetic`);
    return data;
  },
  async getProductCompletenesses(id: number) {
    const { data } = await apiService().get<GetProductCompletenessesResponse>(`company/${id}/productCompleteness`);
    return data;
  },
  async getProductStates(id: number) {
    const { data } = await apiService().get<GetProductStatesResponse>(`company/${id}/productState`);
    return data;
  },
  async postProductType(id: number, body: PostTypePayloadRequest) {
    const { data } = await apiService().post<PostTypeResponse>(`company/${id}/productType`, body);
    return data;
  },
  async postProductUsage(id: number, body: PostProductAttributeValuePayloadRequest) {
    const { data } = await apiService().post<PostProductAttributeValueResponse>(`company/${id}/productUsage`, body);
    return data;
  },
  async postProductPackaging(id: number, body: PostProductAttributeValuePayloadRequest) {
    const { data } = await apiService().post<PostProductAttributeValueResponse>(`company/${id}/productPackaging`, body);
    return data;
  },
  async postProductFuntionality(id: number, body: PostProductAttributeValuePayloadRequest) {
    const { data } = await apiService().post<PostProductAttributeValueResponse>(`company/${id}/productFunctionality`, body);
    return data;
  },
  async postProductAesthetic(id: number, body: PostProductAttributeValuePayloadRequest) {
    const { data } = await apiService().post<PostProductAttributeValueResponse>(`company/${id}/productAesthetic`, body);
    return data;
  },
  async postProductCompleteness(id: number, body: PostProductAttributeValuePayloadRequest) {
    const { data } = await apiService().post<PostProductAttributeValueResponse>(`company/${id}/productCompleteness`, body);
    return data;
  },
  async postProductState(id: number, body: PostProductAttributeValuePayloadRequest) {
    const { data } = await apiService().post<PostProductAttributeValueResponse>(`company/${id}/productState`, body);
    return data;
  },
  async postWarehouseType(id: number, body: PostTypePayloadRequest) {
    const { data } = await apiService().post<PostTypeResponse>(`company/${id}/warehouseType`, body);
    return data;
  },
  async postLocationType(id: number, body: PostTypePayloadRequest) {
    const { data } = await apiService().post<PostTypeResponse>(`company/${id}/locationType`, body);
    return data;
  },
  async postContainerType(id: number, body: PostTypePayloadRequest) {
    const { data } = await apiService().post<PostTypeResponse>(`company/${id}/containerType`, body);
    return data;
  },
  async postChannelType(id: number, body: PostTypePayloadRequest) {
    const { data } = await apiService().post<PostTypeResponse>(`company/${id}/channelType`, body);
    return data;
  },
  async postAcquisitionType(id: number, body: PostTypePayloadRequest) {
    const { data } = await apiService().post<PostTypeResponse>(`company/${id}/acquisitionType`, body);
    return data;
  },
  async postReceptionType(id: number, body: PostTypePayloadRequest) {
    const { data } = await apiService().post<PostTypeResponse>(`company/${id}/receptionType`, body);
    return data;
  },
  async postProductCategory(id: number, body: PostProductCategoryPayloadRequest) {
    const { data } = await apiService().post<PostProductCategoryResponse>(`company/${id}/productCategory`, body);
    return data;
  },
  async postContainerCategory(id: number, body: PostContainerCategoryPayloadRequest) {
    const { data } = await apiService().post<PostContainerCategoryResponse>(`company/${id}/containerCategory`, body);
    return data;
  },
  async postFormat(id: number, body: PostFormatPayloadRequest) {
    const { data } = await apiService().post<PostFormatResponse>(`company/${id}/productFormat`, body);
    return data;
  },
  async postGenre(id: number, body: PostGenrePayloadRequest) {
    const { data } = await apiService().post<PostGenreResponse>(`company/${id}/productGenre`, body);
    return data;
  },
  async postPriceRange(id: number, body: PostPriceRangePayloadRequest) {
    const { data } = await apiService().post<PostPriceRangeResponse>(`company/${id}/priceRange`, body);
    return data;
  },
  async putProductType(cId: number, tId: number, body: PutTypePayloadRequest) {
    const { data } = await apiService().put<PutTypeResponse>(
      `company/${cId}/productType/${tId}`,
      body
    );
    return data;
  },
  async putProductUsage(cId: number, aId: number, body: PutProductAttributeValuePayloadRequest) {
    const { data } = await apiService().put<PutProductAttributeValueResponse>(`company/${cId}/productUsage/${aId}`, body);
    return data;
  },
  async putProductPackaging(cId: number, aId: number, body: PutProductAttributeValuePayloadRequest) {
    const { data } = await apiService().put<PutProductAttributeValueResponse>(`company/${cId}/productPackaging/${aId}`, body);
    return data;
  },
  async putProductFuntionality(cId: number, aId: number, body: PutProductAttributeValuePayloadRequest) {
    const { data } = await apiService().put<PutProductAttributeValueResponse>(`company/${cId}/productFunctionality/${aId}`, body);
    return data;
  },
  async putProductAesthetic(cId: number, aId: number, body: PutProductAttributeValuePayloadRequest) {
    const { data } = await apiService().put<PutProductAttributeValueResponse>(`company/${cId}/productAesthetic/${aId}`, body);
    return data;
  },
  async putProductCompleteness(cId: number, aId: number, body: PutProductAttributeValuePayloadRequest) {
    const { data } = await apiService().put<PutProductAttributeValueResponse>(`company/${cId}/productCompleteness/${aId}`, body);
    return data;
  },
  async putProductState(cId: number, aId: number, body: PutProductAttributeValuePayloadRequest) {
    const { data } = await apiService().put<PutProductAttributeValueResponse>(`company/${cId}/productState/${aId}`, body);
    return data;
  },
  async putWarehouseType(cId: number, tId: number, body: PutTypePayloadRequest) {
    const { data } = await apiService().put<PutTypeResponse>(
      `company/${cId}/warehouseType/${tId}`,
      body
    );
    return data;
  },
  async putLocationType(cId: number, tId: number, body: PutTypePayloadRequest) {
    const { data } = await apiService().put<PutTypeResponse>(
      `company/${cId}/locationType/${tId}`,
      body
    );
    return data;
  },
  async putContainerType(cId: number, tId: number, body: PutTypePayloadRequest) {
    const { data } = await apiService().put<PutTypeResponse>(
      `company/${cId}/containerType/${tId}`,
      body
    );
    return data;
  },
  async putChannelType(cId: number, tId: number, body: PutTypePayloadRequest) {
    const { data } = await apiService().put<PutTypeResponse>(
      `company/${cId}/channelType/${tId}`,
      body
    );
    return data;
  },
  async putAcquisitionType(cId: number, tId: number, body: PutTypePayloadRequest) {
    const { data } = await apiService().put<PutTypeResponse>(
      `company/${cId}/acquisitionType/${tId}`,
      body
    );
    return data;
  },
  async putReceptionType(cId: number, tId: number, body: PutTypePayloadRequest) {
    const { data } = await apiService().put<PutTypeResponse>(
      `company/${cId}/receptionType/${tId}`,
      body
    );
    return data;
  },
  async putProductCategory(cId: number, tId: number, body: PutCategoryPayloadRequest) {
    const { data } = await apiService().put<PutCategoryResponse>(
      `company/${cId}/productCategory/${tId}`,
      body
    );
    return data;
  },
  async putContainerCategory(cId: number, tId: number, body: PutCategoryPayloadRequest) {
    const { data } = await apiService().put<PutCategoryResponse>(
      `company/${cId}/containerCategory/${tId}`,
      body
    );
    return data;
  },
  async putFormat(cId: number, tId: number, body: PutFormatPayloadRequest) {
    const { data } = await apiService().put<PutFormatResponse>(
      `company/${cId}/productFormat/${tId}`,
      body
    );
    return data;
  },
  async putGenre(cId: number, tId: number, body: PutGenrePayloadRequest) {
    const { data } = await apiService().put<PutGenreResponse>(
      `company/${cId}/productGenre/${tId}`,
      body
    );
    return data;
  },
  async putPriceRange(cId: number, tId: number, body: PutPriceRangePayloadRequest) {
    const { data } = await apiService().put<PutPriceRangeResponse>(
      `company/${cId}/priceRange/${tId}`,
      body
    );
    return data;
  },
  async deleteProductType(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteTypeResponse>(
      `company/${cId}/productType/${tId}`
    );
    return data;
  },
  async deleteProductUsage(cId: number, aId: number) {
    const { data } = await apiService().delete<DeleteProductAttributeResponse>(`company/${cId}/productUsage/${aId}`);
    return data;
  },
  async deleteProductPackaging(cId: number, aId: number) {
    const { data } = await apiService().delete<DeleteProductAttributeResponse>(`company/${cId}/productPackaging/${aId}`);
    return data;
  },
  async deleteProductFuntionality(cId: number, aId: number) {
    const { data } = await apiService().delete<DeleteProductAttributeResponse>(`company/${cId}/productFunctionality/${aId}`);
    return data;
  },
  async deleteProductAesthetic(cId: number, aId: number) {
    const { data } = await apiService().delete<DeleteProductAttributeResponse>(`company/${cId}/productAesthetic/${aId}`);
    return data;
  },
  async deleteProductCompleteness(cId: number, aId: number) {
    const { data } = await apiService().delete<DeleteProductAttributeResponse>(`company/${cId}/productCompleteness/${aId}`);
    return data;
  },
  async deleteProductState(cId: number, aId: number) {
    const { data } = await apiService().delete<DeleteProductAttributeResponse>(`company/${cId}/productState/${aId}`);
    return data;
  },
  async deleteWarehouseType(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteTypeResponse>(
      `company/${cId}/warehouseType/${tId}`
    );
    return data;
  },
  async deleteLocationType(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteTypeResponse>(
      `company/${cId}/locationType/${tId}`
    );
    return data;
  },
  async deleteContainerType(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteTypeResponse>(
      `company/${cId}/containerType/${tId}`
    );
    return data;
  },
  async deleteChannelType(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteTypeResponse>(
      `company/${cId}/channelType/${tId}`
    );
    return data;
  },
  async deleteAcquisitionType(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteTypeResponse>(
      `company/${cId}/acquisitionType/${tId}`
    );
    return data;
  },
  async deleteReceptionType(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteTypeResponse>(
      `company/${cId}/receptionType/${tId}`
    );
    return data;
  },
  async deleteProductCatergory(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteCategoryResponse>(
      `company/${cId}/productCategory/${tId}`
    );
    return data;
  },
  async deleteContainerCatergory(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteCategoryResponse>(
      `company/${cId}/containerCategory/${tId}`
    );
    return data;
  },
  async deleteFormat(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteFormatResponse>(
      `company/${cId}/productFormat/${tId}`
    );
    return data;
  },
  async deleteGenre(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteGenreResponse>(
      `company/${cId}/productGenre/${tId}`
    );
    return data;
  },
  async deletePriceRange(cId: number, tId: number) {
    const { data } = await apiService().delete<DeletePriceRangeResponse>(
      `company/${cId}/priceRange/${tId}`
    );
    return data;
  },
  async getContainerRecipientTypes(id: number) {
    const { data } = await apiService().get<GetContainerRecipientTypesResponse>(`company/${id}/containerRecipientTypes`, { params: { size: 10000 } });
    console.log(data);
    return data;
  },
  async postContainerRecipientType(id: number, body: PostTypePayloadRequest) {
    const { data } = await apiService().post<PostTypeResponse>(`company/${id}/containerRecipientType`, body);
    return data;
  },
  async putContainerRecipientType(cId: number, tId: number, body: PutTypePayloadRequest) {
    const { data } = await apiService().put<PutTypeResponse>(`company/${cId}/containerRecipientType/${tId}`, body);
    return data;
  },
  async deleteContainerRecipientType(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteTypeResponse>(`company/${cId}/containerRecipientType/${tId}`);
    return data;
  },
};
